<div tiimeFormColumn>
  <app-mission-acceptance-form-row label="Type de dossier" required tiimeFormRow>
    <app-code-and-label-select
      class="control-container"
      [errorMessage]="form.typeErrorMessage"
      errorMessageMode="without"
      label=""
      [allowEmptyOption]="false"
      [small]="true"
      [control]="form.controls.type"
      [options]="types()"
    ></app-code-and-label-select>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row label="Honoraires mensuels HT" tiimeFormRow>
    <tiime-input-container
      class="control-container"
      label="Honoraires mensuels HT"
      fixedLabel
      small
      contentId="monthly_billed_plan"
    >
      <input
        id="monthly_billed_plan"
        autocomplete="off"
        placeholder="Honoraires mensuels HT"
        appDigitOnly
        [decimal]="true"
        [roundDecimal]="false"
        [formControl]="form.controls.monthlyBilledPlan"
      />
    </tiime-input-container>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row label="CA prévisionnel" tiimeFormRow>
    <tiime-input-container
      class="control-container"
      label="CA prévisionnel"
      fixedLabel
      small
      contentId="ca_forecast_amount"
    >
      <input
        id="ca_forecast_amount"
        autocomplete="off"
        placeholder="CA prévisionnel"
        appDigitOnly
        [decimal]="true"
        [roundDecimal]="false"
        [formControl]="form.controls.caForecastAmount"
      />
    </tiime-input-container>
  </app-mission-acceptance-form-row>
</div>
@if (form.controls.type.value === MissionAcceptanceType.previousAccountantRecovery) {
  <div tiimeFormTitle>Lettre de confraternité</div>
  <div tiimeFormColumn>
    <app-mission-acceptance-form-row
      label="La lettre au confrère (prévue à l'article 163 du Code de déontologie) a-t-elle été envoyée ?"
      required
      tiimeFormRow
    >
      <mat-button-toggle-group class="control-container" [formControl]="form.controls.previousAccountantContacted">
        <mat-button-toggle [value]="true">Oui</mat-button-toggle>
        <mat-button-toggle [value]="false">Non</mat-button-toggle>
      </mat-button-toggle-group>
    </app-mission-acceptance-form-row>
    <app-mission-acceptance-form-row label="Date d'envoi de la lettre de confraternité" required tiimeFormRow>
      <tiime-input-container
        class="control-container"
        label="Date d'envoi"
        fixedLabel
        small
        contentId="previous_accountant_letter_date"
      >
        <input
          id="previous_accountant_letter_date"
          placeholder="Date d'envoi"
          autocomplete="off"
          [formControl]="form.controls.previousAccountantLetterDate"
          [matDatepicker]="datePicker"
          autocomplete="off"
        />
        <mat-icon
          role="button"
          color="primary"
          class="calendar-icon"
          fontSet="fontastic"
          fontIcon="icon-calendar"
          tiimeSuffix
          (click)="datePicker.open()"
        ></mat-icon>
        <mat-datepicker #datePicker></mat-datepicker>
      </tiime-input-container>
    </app-mission-acceptance-form-row>
    <app-mission-acceptance-form-row
      label="Existe-t-il une opposition à notre entrée en fonction ou des remarques ont-elles été formulées par le confrère
    lors de la prise de contact ?"
      required
      tiimeFormRow
    >
      <mat-button-toggle-group
        class="control-container"
        [formControl]="form.controls.previousAccountantOppositionExisted"
      >
        <mat-button-toggle [value]="true">Oui</mat-button-toggle>
        <mat-button-toggle [value]="false">Non</mat-button-toggle>
      </mat-button-toggle-group>
    </app-mission-acceptance-form-row>
  </div>
}
@if (form.controls.type.value === MissionAcceptanceType.creation) {
  <div tiimeFormTitle>Informations complémentaires création de société</div>
  <div tiimeFormColumn>
    <app-mission-acceptance-form-row
      label="Le ou les associés de la société en création sont-ils actionnaires de sociétés à l’étranger ?"
      required
      tiimeFormRow
    >
      <mat-button-toggle-group class="control-container" [formControl]="form.controls.directorsOwnersStrangerCompanies">
        <mat-button-toggle [value]="true">Oui</mat-button-toggle>
        <mat-button-toggle [value]="false">Non</mat-button-toggle>
      </mat-button-toggle-group>
    </app-mission-acceptance-form-row>
    <app-mission-acceptance-form-row
      label="Le ou les associés de la société en création sont-ils résidents français ?"
      required
      tiimeFormRow
    >
      <mat-button-toggle-group class="control-container" [formControl]="form.controls.directorsFrenchResidents">
        <mat-button-toggle [value]="true">Oui</mat-button-toggle>
        <mat-button-toggle [value]="false">Non</mat-button-toggle>
      </mat-button-toggle-group>
    </app-mission-acceptance-form-row>
    <app-mission-acceptance-form-row
      label="Le ou les associés ont-ils déjà créé une ou plusieurs sociétés, actuellement en liquidation ?"
      required
      tiimeFormRow
    >
      <mat-button-toggle-group
        class="control-container"
        [formControl]="form.controls.directorsOwnersLiquidationCompanies"
      >
        <mat-button-toggle [value]="true">Oui</mat-button-toggle>
        <mat-button-toggle [value]="false">Non</mat-button-toggle>
      </mat-button-toggle-group>
    </app-mission-acceptance-form-row>
    <app-mission-acceptance-form-row
      label="Le ou les associés possèdent-ils d'autres sociétés dont la comptabilité a été confiée à un autre expert-comptable
    ?"
      required
      tiimeFormRow
    >
      <mat-button-toggle-group
        class="control-container"
        [formControl]="form.controls.directorsOwnersOtherAccountantCompanies"
      >
        <mat-button-toggle [value]="true">Oui</mat-button-toggle>
        <mat-button-toggle [value]="false">Non</mat-button-toggle>
      </mat-button-toggle-group>
    </app-mission-acceptance-form-row>
  </div>
}
<div tiimeFormTitle>Description de l'activité et des particularités du dossier</div>
<tiime-input-container class="activity_comment" contentId="internal-comment">
  <textarea
    id="activity_comment"
    type="text"
    [formControl]="form.controls.activityComment"
    cdkTextareaAutosize
    cdkAutosizeMinRows="2"
  ></textarea>
</tiime-input-container>
<div tiimeFormTitle>Lettres de mission signées</div>
@if (filesForm.controls | map: fileFormsWithContractLdm : (filesForm.valueChanges | async); as files) {
  @if (files.length > 0) {
    <app-mission-acceptance-files-form-table
      [users]="users()"
      [displayedColumns]="fileFormsWithoutContractLdmColumns"
      [filesForms]="files"
      (removeFile)="emitRemoveFile($event)"
      (downloadFile)="emitDownloadFile($event)"
      (openFileInNewTab)="emitOpenFileInNewTab($event)"
    />
  }
}
<div class="add-file-container">
  @if (canAddContractLdmFromContract()) {
    <button tiime-button color="primary" [disabled]="filesForm.disabled" (click)="emitAddContractFile()">
      <mat-icon svgIcon="icon-contrats"></mat-icon>
      Intégrer depuis les contrats
    </button>
    OU
  }
  <ng-container [ngTemplateOutlet]="addFileButton" [ngTemplateOutletContext]="addContractLdmContext"></ng-container>
</div>

<div tiimeFormTitle class="piece-files-form-title">
  Pièces jointes de l'acceptation
  @if (form.missingIdentityPieceErrorMessage?.message; as missingIdentityPieceErrorMessage) {
    <div class="piece-files-error-container">
      {{ missingIdentityPieceErrorMessage }}
      <mat-icon color="warn" svgIcon="icon-warning"></mat-icon>
    </div>
  }
</div>
@if (filesForm.controls | map: fileFormsWithoutContractLdm : (filesForm.valueChanges | async); as files) {
  @if (files.length > 0) {
    <app-mission-acceptance-files-form-table
      [filesForms]="files"
      [fileTypes]="fileTypesWithoutContractLdm()"
      [users]="users()"
      (removeFile)="emitRemoveFile($event)"
      (downloadFile)="emitDownloadFile($event)"
      (openFileInNewTab)="emitOpenFileInNewTab($event)"
    />
  }
}

@if (identityPieceIsNeededAndMissing()) {
  <div
    class="add-file-container add-identity-piece-file-container"
    [class.warn]="form.missingIdentityPieceErrorMessage?.message"
  >
    <ng-container [ngTemplateOutlet]="addFileButton" [ngTemplateOutletContext]="addIdentityPieceContext"></ng-container>
  </div>
}

<div class="add-file-container">
  <ng-container [ngTemplateOutlet]="addFileButton" [ngTemplateOutletContext]="addOtherContext"></ng-container>
</div>

<ng-template #addFileButton let-type="type" let-text="text">
  <button type="button" tiime-button color="primary" [disabled]="filesForm.disabled" (click)="importFile(fileSelector)">
    <mat-icon fontSet="fontastic" fontIcon="icon-ic-add-1"></mat-icon>
    {{ text }}
    <input
      hidden
      id="fileSelector"
      type="file"
      multiple
      [accept]="acceptedTypes"
      (change)="emitOnFileSelected(fileSelector.files, type)"
      (cancel)="$event.stopPropagation()"
      (close)="$event.stopPropagation()"
      #fileSelector
    />
  </button>
</ng-template>
